/**
 * Lead drop variant 4 — CMS selects ERP vs LSQ for POST /leads/verify-drop4.
 */
export type LeadDrop4IntegrationPayload = {
  destination: "erp" | "lsq";
  lsq?: Record<string, unknown>;
};

/** CMS / API may send `LSQ`, spaces, or omit field — only `lsq` selects LSQ; everything else is ERP. */
export function normalizeLeadDrop4Destination(raw: unknown): "erp" | "lsq" {
  const s = String(raw ?? "erp").trim().toLowerCase();
  return s === "lsq" ? "lsq" : "erp";
}

/** Build JSON-safe integration for POST body (`undefined` values must not drop `destination`). */
export function serializeLeadDrop4IntegrationForApi(
  integration: LeadDrop4IntegrationPayload | null | undefined,
): { destination: "erp" | "lsq"; lsq?: Record<string, unknown> } {
  const destination = normalizeLeadDrop4Destination(integration?.destination);
  if (destination === "lsq") {
    const lsq = integration?.lsq;
    if (lsq && typeof lsq === "object" && !Array.isArray(lsq)) {
      return { destination: "lsq", lsq };
    }
    return { destination: "lsq" };
  }
  return { destination: "erp" };
}

type FormLike = Record<string, unknown> | null | undefined;

function mergeAdditionalFields(row: FormLike): Record<string, unknown> {
  if (!row || typeof row !== "object") return {};
  const r = { ...row } as Record<string, unknown>;
  const additional = r.additional_fields;
  delete r.additional_fields;
  if (additional && typeof additional === "object") {
    Object.assign(r, additional as Record<string, unknown>);
  }
  return r;
}

export function integrationPayloadFromLeadDrop4Cms(
  data: FormLike,
): LeadDrop4IntegrationPayload {
  const flattened = mergeAdditionalFields(data);
  const destination = normalizeLeadDrop4Destination(
    flattened.lead_integration_destination,
  );
  const lsq = flattened.lsq_options;
  if (destination === "lsq" && lsq && typeof lsq === "object") {
    return { destination: "lsq", lsq: lsq as Record<string, unknown> };
  }
  if (destination === "erp") {
    return { destination: "erp" };
  }
  return { destination: "lsq" };
}
